module.exports = __webpack_public_path__ + "images/no_signal.433ba4862d49ca234cae2f0408cb81d9.png";